// frontend/src/api/rulesClient.ts
import { apiFetch } from "./baseClient";
import { RulesUpdateRequest } from "../model/backendTypes";


/**
 * sendRulesXml:
 *  - schickt rules_xml sofort ans Backend
 *  - wartet NICHT auf Solver/Plan
 *  - Plan-Polling läuft unabhängig in planClient.ts
 */
export async function sendRulesXml(
  userId: number,
  projectId: number,
  rulesXml: string,
): Promise<void> {
  const payload: RulesUpdateRequest = {
    user_id: userId,
    project_id: projectId,
    rules_xml: rulesXml,
  };

  const resp = await apiFetch(`/api/projects/rules`, {
    method: "POST",
    body: payload as any,
  });

  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(text || `HTTP ${resp.status}`);
  }
}
